


































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as def from "@/definitions";

import { BarcodeLayer } from "@/model/document2/page/surface/design/layer/barcodeLayer";
import { ColorConstruct } from "@/utilityModels/colorConstruct";

import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

const isElement = (x: any): x is HTMLTextAreaElement =>
  x instanceof HTMLTextAreaElement;

@Component({
  components: {
    DropdownList,
    ArrowDown,
    ArrowRight,
    CheckBoxOn
  }
})
export default class BarcodeStyle extends Vue {
    @Prop()
    private layer!: BarcodeLayer;

    private changeInputMode(mode)
    {
        this.$store.dispatch("changeInputMode", mode);
    }

    private onFocusInput()
    {
        this.changeInputMode(1);
    }
    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend: true
    };

    barcodeStyleContentsOpenAnimate = false;
    barcodeStyleContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
            this.barcodeStyleContentsCloseAnimate = true;
            setTimeout(() => {
                this.barcodeStyleContentsCloseAnimate = false;
                this.barcodeStyleContentsOpenAnimate = false;
                this.openStatus.opend = false;
            }, 200);
        } else {
            this.openStatus.opend = true;
            this.barcodeStyleContentsOpenAnimate = true;
            setTimeout(() => {
                this.barcodeStyleContentsOpenAnimate = false;
            }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    //↓↓↓↓↓バーコード文字列↓↓↓↓
    get text(): string {
        return this.layer.text;
    }

    confirmText(){
        if (!isElement(this.$refs.textarea)) return;
        this.$refs.textarea.blur()
    }

    //↑↑↑↑↑バーコード文字列↑↑↑↑↑

    //↓↓↓↓↓タイプ↓↓↓↓↓
    get barcodeType(): number {
        return this.layer.barcodeType;
    }

    isBarcodeTypeDropdownVisible = false;
    private get barcodeTypeDropdownItems() {
        var items = new Array();
            items.push({
            id: 0,
            isSelected: this.barcodeType == 0,
            label: "JAN(標準)"
        });
            items.push({
            id: 1,
            isSelected: this.barcodeType == 1,
            label: "JAN(短縮)"
        });
            items.push({
            id: 2,
            isSelected: this.barcodeType == 2,
            label: "物流(標準)"
        });
            items.push({
            id: 3,
            isSelected: this.barcodeType == 3,
            label: "物流(拡張)"
        });
            items.push({
            id: 4,
            isSelected: this.barcodeType == 4,
            label: "物流(アドオン)"
        });
            items.push({
            id: 5,
            isSelected: this.barcodeType == 5,
            label: "ITF"
        });
            items.push({
            id: 6,
            isSelected: this.barcodeType == 6,
            label: "NW-7"
        });
            items.push({
            id: 7,
            isSelected: this.barcodeType == 7,
            label: "CODE39"
        });
            items.push({
            id: 8,
            isSelected: this.barcodeType == 8,
            label: "CODE128"
        });
        items.push({
            id: 9,
            isSelected: this.barcodeType == 9,
            label: "GS1(標準)"
        });
        items.push({
            id: 10,
            isSelected: this.barcodeType == 10,
            label: "GS1(拡張)"
        });
        items.push({
            id: 11,
            isSelected: this.barcodeType == 11,
            label: "ISBN"
        });
        items.push({
            id: 12,
            isSelected: this.barcodeType == 12,
            label: "GS1-128"
        });
        return items;
    }
    //↑↑↑↑↑タイプ↑↑↑↑↑

    // ↓↓↓↓↓文字表示↓↓↓↓↓
    get showNumber(): boolean {
        return this.layer.showNumber;
    }
    private changeShowNumber() {
        var newValue = this.layer.showNumber == true ? false : true;
        this.changeLayerProperty(newValue, "showNumber");
    }

    private setType(value: number, propertyName: string) {
        this.isBarcodeTypeDropdownVisible = false;

        this.changeLayerProperty(value, propertyName);
    }

    private onSetText(value : any, isFinish : boolean = true)
    {
        if(isFinish)
        {
            this.changeInputMode(0);
        }
        else
        {
            this.changeInputMode(1);
        }
        this.changeLayerProperty(value, "text", isFinish);
    }

    private changeLayerProperty(value : any, propertyName : string, isFinish : boolean = false, isOnce : boolean = false) 
    {
        this.$emit("doCommand", "changeLayerProperty", {
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
